import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RelinkCodeSectionOrphanMutationVariables = Types.Exact<{
  orphanId: Types.Scalars['uuid']['input'];
  codeSectionId: Types.Scalars['uuid']['input'];
}>;


export type RelinkCodeSectionOrphanMutation = { __typename?: 'mutation_root', relink_code_section_orphan?: { __typename?: 'RelinkCodeSectionOrphanOutput', relinked: boolean } | null };


export const RelinkCodeSectionOrphanDocument = gql`
    mutation relinkCodeSectionOrphan($orphanId: uuid!, $codeSectionId: uuid!) {
  relink_code_section_orphan(
    input: {orphan_id: $orphanId, code_section_id: $codeSectionId}
  ) {
    relinked
  }
}
    `;
export type RelinkCodeSectionOrphanMutationFn = Apollo.MutationFunction<RelinkCodeSectionOrphanMutation, RelinkCodeSectionOrphanMutationVariables>;

/**
 * __useRelinkCodeSectionOrphanMutation__
 *
 * To run a mutation, you first call `useRelinkCodeSectionOrphanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRelinkCodeSectionOrphanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [relinkCodeSectionOrphanMutation, { data, loading, error }] = useRelinkCodeSectionOrphanMutation({
 *   variables: {
 *      orphanId: // value for 'orphanId'
 *      codeSectionId: // value for 'codeSectionId'
 *   },
 * });
 */
export function useRelinkCodeSectionOrphanMutation(baseOptions?: Apollo.MutationHookOptions<RelinkCodeSectionOrphanMutation, RelinkCodeSectionOrphanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RelinkCodeSectionOrphanMutation, RelinkCodeSectionOrphanMutationVariables>(RelinkCodeSectionOrphanDocument, options);
      }
export type RelinkCodeSectionOrphanMutationHookResult = ReturnType<typeof useRelinkCodeSectionOrphanMutation>;
export type RelinkCodeSectionOrphanMutationResult = Apollo.MutationResult<RelinkCodeSectionOrphanMutation>;
export type RelinkCodeSectionOrphanMutationOptions = Apollo.BaseMutationOptions<RelinkCodeSectionOrphanMutation, RelinkCodeSectionOrphanMutationVariables>;